import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {map, tap, catchError} from "rxjs/operators";
import {Entrepot} from "../../models/entrepot";
import { appendErpUserStationParams } from '../erp-api-query.helper';

@Injectable({
  providedIn: 'root'
})
export class WarehouseService {

    private apiUrl = environment.stock_url;
    private baseUrl = `${this.apiUrl.replace(/\/$/, '')}/api/entrepots`;
    private erpBaseUrl = `${String(environment.transfertsEntrepotsErpBaseUrl ?? '').replace(/\/$/, '')}`;

    constructor(private http: HttpClient) { }

    getAllEntrepotsErpForStockTransfert(): Observable<Array<{ id: number; libelle?: string; nom?: string }>> {
        const url = `${this.erpBaseUrl}/api/entrepots/entrepot/all`;
        const params = appendErpUserStationParams(new HttpParams());
        return this.http.get<any>(url, { params }).pipe(
            map((response) => {
                let rows: any[] = [];
                if (Array.isArray(response)) {
                    rows = response;
                } else if (Array.isArray(response?.data)) {
                    rows = response.data;
                } else if (Array.isArray(response?.entrepots)) {
                    rows = response.entrepots;
                } else if (Array.isArray(response?.data?.entrepots)) {
                    rows = response.data.entrepots;
                }
                return rows;
            }),
            catchError((error) => {
                throw error;
            })
        );
    }

    getAllWarehouses(userId: number, stationId: number): Observable<any[]> {
        const params = new HttpParams()
            .set('user_id', userId.toString())
            .set('station_id', stationId.toString());

        const url = `${this.baseUrl}?user_id=${userId}&station_id=${stationId}`;

        return this.http.get<any>(this.baseUrl, { params }).pipe(
            map(response => {

                let entrepots: any[] = [];
                if (response?.data?.[0]?.entrepots) {
                    entrepots = response.data[0].entrepots;
                } else if (response?.data && Array.isArray(response.data)) {
                    entrepots = response.data;
                } else if (Array.isArray(response)) {
                    entrepots = response;
                } else if (response?.entrepots && Array.isArray(response.entrepots)) {
                    entrepots = response.entrepots;
                } else if (response?.data && !Array.isArray(response.data)) {
                    entrepots = response.data.entrepots || [];
                }
                
                return entrepots;
            }),
            catchError(error => {
                throw error;
            })
        );
    }


    addWarehouse(stationId: number, warehouse: Entrepot): Observable<Entrepot> {
        const url = `${this.baseUrl}`;
        const payload = {
            ...warehouse,
            station_id: stationId
        };
        return this.http.post<Entrepot>(url, payload);
    }

    updateWarehouse(warehouseId: number, userId: number, stationId: number, payload: Entrepot): Observable<Entrepot> {
        return this.http.put<Entrepot>(`${this.baseUrl}/${warehouseId}`, payload, {
            params: {
                user_id: userId.toString(),
                station_id: stationId.toString()
            }
        });
    }

    detailEntrepot(id: number, userId: number, stationId: number): Observable<Entrepot> {
        return this.http.get<Entrepot>(`${this.baseUrl}/${id}`, {
            params: {
                user_id: userId.toString(),
                station_id: stationId.toString()
            }
        });
    }

    deleteWarehouse(warehouseId: number, userId: number, stationId: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${warehouseId}`, {
            params: {
                user_id: userId.toString(),
                station_id: stationId.toString()
            }
        });
    }

    resetStockEntrepot(entrepotId: number, userId: number, password: string): Observable<any> {
        const url = `${this.baseUrl}/${entrepotId}/reset-stock`;
        const payload = {
            user_id: userId,
            password: password
        };
        return this.http.post<any>(url, payload).pipe(
            catchError(error => {
                throw error;
            })
        );
    }

}
